exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".event-title {\n  margin-bottom: 3.5rem; }\n  .event-title h1 {\n    font-weight: bold;\n    font-size: 3.3em;\n    margin-bottom: 0.5rem; }\n  .event-title h2 {\n    font-size: 2.7em;\n    margin-bottom: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/pages/EventDetailPage/EventTitle/EventTitle.scss
// module id = 1571
// module chunks = 0